module.exports = __webpack_public_path__ + "img/add-image19.1d120ad2.png";